export default __webpack_public_path__ + "6db0f16e6dd31f56755b762ffd67ae1c.otf";